module.exports = __webpack_public_path__ + "img/23.93fc9457.png";